((AccountLoginSignup, $) => {

  const $dom = {};

  const cacheDom = () => {
    $dom.body = $('body');
    $dom.checkResetPassword = $('.reset-check[data-successful-reset="true"]');
    $dom.customerLoginForm = $('form#customer_login');
    $dom.recoverCustomerPasswordForm = $('form[action="/account/recover"]');
    $dom.createCustomerForm = $('form#create_customer');
  };

  const toggleAccountPagePopup = (popup_handle) => {
    let $popup = $('.js-account-page-popup[data-popup="' + popup_handle + '"]');
    if($popup.length > 0) {
      if($popup.hasClass('enabled')) {
        $popup.removeClass('enabled');
      } else {
        $popup.addClass('enabled');
        $('.js-account-page-popup').not($popup).removeClass('enabled');
      }
    }
  };

  const checkForResetPassword = () => {
    if($dom.checkResetPassword.length > 0) {
      toggleAccountPagePopup('password-recover-successful');
    }
  };

  const handleAccountPageFormSubmit = (event) => {
    let $form = $(event.currentTarget),
        formIsValid = true,
        $form_error_message = $form.find('.form-error-message'),
        validateEmail = (email) => {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(email).toLowerCase());
        };
    $form.find('input:not([type="submit"])').each(function(index, field) {
      let fieldIsValid = true;
      if($(field).is('[name*="email"]')) {
        if($(field).val().trim() == ''
        || true !== validateEmail($(field).val())) {
          fieldIsValid = false;
        }
      } else {
        if($(field).val().trim() == '') {
          fieldIsValid = false;
        }
      }
      if(true === fieldIsValid) {
        $(field).closest('.input-wrapper').removeClass('field-invalid');
      } else {
        $(field).closest('.input-wrapper').addClass('field-invalid');
        formIsValid = false;
      }
    });
    if(true === formIsValid) {
      $form_error_message.hide();
    } else {
      event.preventDefault();
      $form_error_message.show();
    }
  };
    
  const bindUIActions = () => {
    
    $dom.customerLoginForm.on('submit', handleAccountPageFormSubmit);
    $dom.recoverCustomerPasswordForm.on('submit', handleAccountPageFormSubmit);
    $dom.createCustomerForm.on('submit', handleAccountPageFormSubmit);

    $('[data-togglepopup]').on('click', (event) => {
      event.preventDefault();
      let $this = $(event.currentTarget),
          popup_handle = $this.attr('data-togglepopup');
      if(typeof popup_handle != 'undefined') {
        toggleAccountPagePopup(popup_handle);
      }
    });

    $('[data-popup] .close-popup').on('click', (event) => {
      event.preventDefault();
      let $this = $(event.currentTarget),
          popup_handle = $this.closest('[data-popup]').attr('data-popup');
      if(typeof popup_handle != 'undefined') {
        toggleAccountPagePopup(popup_handle);
      }
    });
    
  };

  const onInit = () => {

    if(window.location.hash === '#recover') {
      toggleAccountPagePopup('recover-password');
    }

    if($dom.body.hasClass('template-customers-login')) {
      checkForResetPassword();
    }

  };
  
  AccountLoginSignup.init = () => {
    cacheDom();
    bindUIActions();
    onInit();
  };

})(window.AccountLoginSignup = window.AccountLoginSignup || {}, jQuery);